export default "__VITE_ASSET__1ewUwjVH__"